import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  makeStyles,
  Button,
  IconButton,
  Drawer,
  Link,
  MenuItem,
  Menu,
} from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";
import MenuIcon from "@material-ui/icons/Menu";
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Slide from '@material-ui/core/Slide';
import PropTypes from 'prop-types';
import Base13Icon from './../../Color graphic - no background.png';
import Base13Logo from './../../Color logo - no background.png';
import FloSQLIcon from './../../Color just logo - no background.png';

import Careers from './Careers';
import Documentation from './Documentation';

const headersData = [
  {
    label: "Home",
    href: "/",
  },
  {
    label: "Pricing",
    href: "/Pricing",
  },
];

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },
  appBar: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: 'black',

  },
  toolbar: {
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent:'center',
    "@media (max-width: 900px)": {
      paddingLeft: 0,
    },
  },
  toolbarTitle: {
    flexGrow: 1,
  },
  logo: {
    width: 165,
    height: 48,
  },
  icon: {
    width: 165,
    height: 48,
  },
  button: {
    margin: theme.spacing(1),
  },
  headerButton: {
    color:"#cbd5e1",
    borderColor:"#cbd5e1",
  '&:hover': {
      color: '#0284c7',
      borderColor: '#0284c7',
    },
  textTransform: 'none'
  },
  loginButton: {
    color:"#cbd5e1",
    borderColor:"#cbd5e1",
    textTransform: 'none',
  '&:hover': {
      borderColor: '#0284c7',
    }
    },
  signupButton: {
    color:"#cbd5e1",
    borderColor:"#cbd5e1",
    textTransform: 'none',
    fontSize: '15px',
    backgroundColor:"#0284c7",
    borderColor:"#0284c7",
    fontWeight: "bold",
    maxWidth: '250px',
  '&:hover': {
      borderColor: '#3fb0e8',
      backgroundColor:"#0284c7",
    }
    },
  image: {
    flex: 1,
    padding: 2,
    width: 100,
    height: 100,
    resizeMode: 'contain'
  },
  menuButton: {
    color:"#cbd5e1",
    borderColor:"#cbd5e1",
    '&:hover': {
      borderColor: '#0284c7',
    },
    fontFamily: "Open Sans, sans-serif",
    fontWeight: 700,
    size: "18px",
    marginLeft: "38px",

  },
  link: {
    margin: theme.spacing(1, 1.5),
    textDecoration: 'none',
    color: 'white',
    underline: 'none',
    hover: {
    "&:hover": {
      color: '#cbd5e1'
      }
    }
  },
}));

export default function Header(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { header, logo, menuButton, toolbar, drawerContainer, appBar, headerButton, loginButton, signupButton, image, link, button, toolbarTitle } = useStyles();

  const displayMobile = () => {

    const handleDrawerOpen = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: true }));
    const handleDrawerClose = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: false }));

    const getDrawerChoices = () => {
      return headersData.map(({ label, href }) => {
        return (
          <Link
            {...{
              component: RouterLink,
              to: href,
              color: "inherit",
              style: { textDecoration: "none" },
              key: label,
            }}
          >
            <MenuItem>{label}</MenuItem>
          </Link>
        );
      });
    };

    return (
      <Toolbar className={toolbar}>
      <Grid container alignItems="flex-end" >
      <Grid xs={10} sm={10} md={10} lg={10} alignItems="flex-end">
      <Box style={{marginLeft:8, marginTop: 4}}><Link href="/"><img className={logo} src={Base13Logo}/></Link></Box>
      </Grid>
      <Grid xs={2} sm={2} md={2} lg={2} alignItems="flex-end">
      <Box style={{marginBottom:6}}>
        <IconButton
          {...{
            edge: "start",
            color: "inherit",
            "aria-label": "menu",
            "aria-haspopup": "true",
            onClick: handleDrawerOpen,
          }}
        >
        <MenuIcon className={menuButton} />
        </IconButton>
        </Box>
        <Drawer
          {...{
            anchor: "right",
            open: drawerOpen,
            onClose: handleDrawerClose,
          }}
        >
          <div>{getDrawerChoices()}</div>
        </Drawer>
        </Grid>
        </Grid>
        </Toolbar>
        );
  };

  const BasicMenu = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
    const handleNav = (nav) => {
      window.location.href = nav;
    };

  return (
    <div>
          <Button
            className={headerButton}
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
          >
            Case Studies
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            keepmounted
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
            style={{justifyContent: "flex-end"}}
          >
            <MenuItem onClick={() => {handleNav("/SMSLiveCaseStudy")}}>Product-Led</MenuItem>
            <MenuItem onClick={() => {handleNav("/StreamLocatorCaseStudy")}}>Ecommerce</MenuItem>
          </Menu>
          </div>
          );
    };

  const displayDesktop = () => {

      return (
        <Toolbar className={toolbar}>
          <Grid container lg={12} spacing={0}>
          <Grid item justify="left" lg={4}>
          <Box
          display="flex"
          alignItems="left"
          justifyContent="left"
          style={{padding:5}}
          >
          <Link href="/"><img className={logo} src={Base13Logo}/></Link>
          </Box>
          </Grid>

          <Grid item justify="center" lg={4}>
          <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{padding:10}}
          >
          <Button variant="text" href='/Pricing' className={headerButton}>Pricing</Button>
          <BasicMenu />
          <Button variant="text" href='https://blog.base13labs.com/' target="_blank" className={headerButton}>Blog</Button>
          </Box>
          </Grid>
          <Grid item justify="right" lg={2}></Grid>
          <Grid item justify="right" lg={2} >
          <Box
          display="flex"
          alignItems="right"
          justifyContent="right"
          style={{padding:10}}
          >
          <Box
          display="flex"
          alignItems="right"
          justifyContent="right"
          style={{paddingLeft:38, paddingRight: 28}}
          />
          <Button variant="outlined" href='/LearnMore' className={signupButton} style={{ flex: 1 }}>
            Talk to an Expert
          </Button>
          {/*<Button variant="outlined" href='https://www.flosql.com/?utm_source=referral&utm_medium=website&utm_campaign=base13header' className={loginButton} startIcon={<img src={FloSQLIcon} style={{ maxWidth:25 }} />} target="_blank" style={{ flex: 1 }}>
            Go to FloSQL
          </Button>*/}
          </Box>
          </Grid>
          </Grid>
          </Toolbar>
          );
    };

  function HideOnScroll(props) {
    const { children, window } = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({ target: window ? window() : undefined });

    return (
      <Slide appear={false} direction="down" in={!trigger}>
        {children}
      </Slide>
      );
    }

    HideOnScroll.propTypes = {
      children: PropTypes.element.isRequired,
      /**
       * Injected by the documentation to work in an iframe.
       * You won't need it on your project.
       */
      window: PropTypes.func,
    };

    const [state, setState] = useState({
      mobileView: false,
      drawerOpen: false
    });

    const { mobileView, drawerOpen } = state;

    useEffect(() => {
      const setResponsiveness = () => {
        return window.innerWidth < 900
          ? setState((prevState) => ({ ...prevState, mobileView: true }))
          : setState((prevState) => ({ ...prevState, mobileView: false }));
      };

      setResponsiveness();
      window.addEventListener("resize", () => setResponsiveness());

      return () => {
        window.removeEventListener("resize", () => setResponsiveness());
      }
    }, []);

    const getMenuButtons = () => {
      return headersData.map(({ label, href }) => {
        return (
          <Button
            {...{
              key: label,
              color: "inherit",
              to: href,
              component: RouterLink,
              className: menuButton,
            }}
          >
            {label}
          </Button>
        );
      });
    };

  return (
  	<HideOnScroll {...props}>
      <AppBar position="fixed" color="default" elevation={0} className={appBar}>
        {mobileView ? displayMobile() : displayDesktop()}
      </AppBar>
     </HideOnScroll>
  );
}